import { type FC } from "react";

import { AppStrings } from "../../../../utils/constants/AppStrings";
import { Form, Input, Select } from "../../../shared";
import useCurrencySymbol from "../../../../hooks/useCurrencySymbol";

import type { CpaActionType } from "./Payment";

import styles from "./CpaConditions.module.css";

const CPA_ACTION_OPTIONS: ReadonlyArray<{ value: CpaActionType; label: string }> = [
  { value: "first_time_deposits", label: AppStrings.FIRST_TIME_DEPOSITS },
  { value: "user_signups", label: AppStrings.USER_SIGNUPS },
];

const CpaConditions: FC = () => {
  const currencySymbol = useCurrencySymbol() ?? "$";

  return (
    <div className={styles.row}>
      <Form.Item
        name={["cpa", "actionType"]}
        label={`${AppStrings.ACTION_TYPE}*`}
        rules={[{ required: true, message: AppStrings.REQUIRED }]}
      >
        <Select
          placeholder={AppStrings.SELECT}
          options={CPA_ACTION_OPTIONS as unknown as { value: string; label: string }[]}
          data-testid="new-affiliate-payment-cpa-action-type"
        />
      </Form.Item>

      <Form.Item
        name={["cpa", "paymentPerAction"]}
        label={`${AppStrings.PAYMENT_PER_ACTION}*`}
        rules={[
          { required: true, message: AppStrings.REQUIRED },
          Form.validators.numericRange({
            min: 0.01,
            message: AppStrings.MUST_BE_GREATER_THAN_0,
          }),
        ]}
      >
        <Input
          prefixIcon={
            <span className={styles.adornment}>{currencySymbol}</span>
          }
          placeholder={"0"}
          inputMode="decimal"
          data-testid="new-affiliate-payment-cpa-amount"
        />
      </Form.Item>
    </div>
  );
};

export default CpaConditions;
